(function(window) {

	const $ = require("jquery");

	/**
	 * Handles the form submission process.
	 * @param {Event} e The event handler.
	 * @return {Void}
	 */
	const onFormSubmit = function(e) {
		if (typeof e !== "undefined")
			e.preventDefault();

		const form = this;
		const data = {};
		$(this).find("input, select, textarea").each(function() {
			let name = $(this).attr("name");
			if (! name)
				return;

			let val = $(this).val();
			if (val && val !== "false")
				data[name] = val;
		});

		data.public_key = "3.14159265358979323846264338327950288419716";

		// Set form pending...
		const submitBtn = $(this).find("input[type=submit]");
		$(submitBtn).attr("disabled", "disabled");
		$(this).addClass("form-processing");

		let endpoint = "painting";
		if (typeof window._quoteFormEndpoint !== "undefined") {
			endpoint = window._quoteFormEndpoint;
			if (typeof endpoint == "string") {
				endpoint = endpoint.replace(/.com.au/g, "");
				endpoint = endpoint.replace(/http:\/\//g, "");
				endpoint = endpoint.replace(/https:\/\//g, "");
				endpoint = endpoint.replace(/mjharris/g, "");
				let s = endpoint.split(".");
				if (s.length > 1)
					endpoint = s[s.length -1];
			}
		}

		$.ajax({
			method: "post",
			url: "https://quote.mjharrisgroup.com.au/" + endpoint + "/",
			data: data
		}).done(function(response) {
			$(submitBtn).remove();
			$(form).append('<div class="message">' + response.message + '</div>');

		}).fail(function(err) {
			$(form).removeClass("form-processing");
			$(form).html('<div class="message">An error occurred sending your enquiry. Please call us on 03 9431 1177.</div>');
		});

	};

	$(document).ready(function() {
		$("[data-bind=quote-form]").on("submit", onFormSubmit);
	});

})(window);
